export default __webpack_public_path__ + "static/media/trustedby5.c5927a13.svg";